const request = {
  methods: {
    adjustRequestDateAndTime(date, time) {
      if (date && time){
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          time.getHours(),
          time.getMinutes()
        );
      }
      return null;
    },
    requestTypeText(type, capitalization = 0) {
      // 0 --> all lower case
      return capitalization === 0
        ? type === "visit"
          ? "visita"
          : type === "lecture"
          ? "palestra"
          : type === "webinar"
          ? "webinar"
          : type === "training"
          ? "treinamento"
          : type === "mentoring"
          ? "mentoria"
          : type === "sponsorship"
          ? "patrocínio"
          : type === "project"
          ? "projeto"
          : type === "other"
          ? "outra ação"
          : "-"
        : capitalization === 1 // 1 --> first upper case
        ? type === "visit"
          ? "Visita"
          : type === "lecture"
          ? "Palestra"
          : type === "webinar"
          ? "Webinar"
          : type === "training"
          ? "Treinamento"
          : type === "mentoring"
          ? "Mentoria"
          : type === "sponsorship"
          ? "Patrocínio"
          : type === "project"
          ? "Projeto"
          : type === "other"
          ? "Outra Ação"
          : "-"
        : // 2 --> all upper case
        type === "visit"
        ? "VISITA"
        : type === "lecture"
        ? "PALESTRA"
        : type === "webinar"
        ? "WEBINAR"
        : type === "training"
        ? "TREINAMENTO"
        : type === "mentoring"
        ? "MENTORIA"
        : type === "sponsorship"
        ? "PATROCÍNIO"
        : type === "project"
        ? "PROJETO"
        : type === "other"
        ? "OUTRA AÇÃO"
        : "-";
    },
    requestStatus(status) {
      return status === "newRequest"
        ? "Solicitação recebida"
        : status === "underEvaluation"
        ? "Aguardando resposta"
        : status === "confirmed"
        ? "Solicitação aceita"
        : status === "alignment"
        ? "Alinhamento com o gestor"
        : status === "preEvent"
        ? "Preparativos pré-evento"
        : status === "waitingCounterparts"
        ? "Enviar contrapartidas"
        : status === "buildingCase"
        ? "Construindo case"
        : status === "finishedWithCounterparts"
        ? "Ação finalizada - com contrapartidas"
        : status === "finishedWithoutCounterparts"
        ? "Ação finalizada - sem contrapartidas"
        : status === "noAvailability"
        ? "Sem disponibilidade empresa"
        : status === "canceledByOrganization"
        ? "Cancelado pela OE"
        : "---";
    },
    requestTypeTreatmentPronoun(type, capitalization = 0) {
      return capitalization === 0 // lower case
        ? type === "webinar" ||
          type === "training" ||
          type === "sponsorship" ||
          type === "project"
          ? "o"
          : "a"
        : type === "webinar" ||
          type === "training" ||
          type === "sponsorship" ||
          type === "project"
        ? "O"
        : "A";
    },
    hasSpecificTime(requestType) {
      return !(
        requestType === "visit" ||
        requestType === "other" ||
        requestType === "sponsorship" ||
        requestType === "project"
      );
    }
  },

  computed: {
    isVisit() {
      return this.request.requestType === "visit";
    },
    isLecture() {
      return this.request.requestType === "lecture";
    },
    isMentoring() {
      return this.request.requestType === "mentoring";
    },
    isTraining() {
      return this.request.requestType === "training";
    },
    isSponsorship() {
      return this.request.requestType === "sponsorship";
    },
    isWebinar() {
      return this.request.requestType === "webinar";
    },
    isOther() {
      return this.request.requestType === "other";
    },
    isProject() {
      return this.request.requestType === "project";
    },
    availablePlants() {
      return this.opportunity.plants;
    },
    availableLectureThemes() {
      return this.opportunity.lecture.themes;
    }
  }
};

export { request };
